/**
 * Convert a local file path (e.g., "./uploads/frames/abc.png") to an API URL
 * for serving via /api/uploads/[...path].
 *
 * 站点以子路径挂载时（NEXT_PUBLIC_BASE_PATH），产出的 URL 也必须带该前缀 ——
 * `<img src="/api/uploads/...">` 不像 next/link 那样会被框架自动加 basePath。
 */
import { BASE_PATH, withBasePath } from "@/lib/base-path";

export function uploadUrl(filePath: string): string {
  // Normalize backslashes to forward slashes (Windows compatibility)
  const normalized = filePath.replace(/\\/g, "/");

  // Already an API URL (with or without the mount prefix) — return as-is
  if (
    normalized.startsWith("/api/uploads/") ||
    (BASE_PATH !== "" && normalized.startsWith(`${BASE_PATH}/api/uploads/`))
  ) {
    return normalized;
  }

  // Strip any prefix ending with "uploads/" (handles ./uploads/, /abs/path/uploads/, etc.)
  const stripped = normalized.replace(/^.*?uploads\//, "");

  return withBasePath(`/api/uploads/${stripped}`);
}
